<template>
  <div class="VvSectionTitle">
    <span class="Title"><slot /></span>
  </div>
</template>

<script>
export default {
  name: 'VvSectionTitle'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.VvSectionTitle {
  text-align: center;

  .Title {
    font-family: Helvetica, sans-serif;
    font-weight: bold;
    font-size: 24px;
    color: black;
    position: relative;
    z-index: 2;

    &::before {
      content: '';
      z-index: -1;
      position: absolute;
      display: block;
      height: 10px;
      background-color: $primary-alt;
      bottom: 0;
      left: -5%;
      width: 110%;
    }
  }
}
</style>
